import { MutableRefObject } from "react";

import PlaybackRateIcon from "../icons/playback-rate.svg";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";

export const PlaybackRateButton = ({
  onClick,
  buttonRef,
}: {
  onClick: () => void;
  buttonRef: MutableRefObject<null | HTMLButtonElement>;
}) => {
  const translations = useTranslations();

  return (
    <PlayerControlButtonComponent
      buttonRef={buttonRef}
      aria-label={translations("playback_speed_header")}
      onClick={onClick}
      interactive
      aria-haspopup="true"
      Icon={<PlaybackRateIcon />}
      hoverText={translations("playback_speed_header")}
    />
  );
};
